import React from 'react';

const Accounting: React.FC = () => {
    return (
        <div>
            <h1>Accounting</h1>
            <p>This is the accounting component for the Assets page.</p>
        </div>
    );
};

export default Accounting;